import {ComponentRef, Injector, TemplateRef} from "@angular/core";
import {ModalInstance} from "./ModalInstance";
import {IModalOptions} from "./IModalOptions";
import {NModalBackdropComponent} from "./components/public_components";

export abstract class ModalRenderer {

  abstract render<T>(type: Function,
                     modalData: any,
                     options: IModalOptions,
                     layerNumber: number): ModalInstance<T>;

  abstract renderTemplate<T>(template: TemplateRef<any>,
                             modalData: any,
                             options: IModalOptions,
                             layerNumber: number): ModalInstance<T>;

  abstract renderBackdrop(inj?: Injector): ComponentRef<NModalBackdropComponent>;

}
